module.exports = __webpack_public_path__ + "static/media/wheat.da6117de.svg";